import { schema } from 'normalizr';
import { deviationSchema } from './deviation';
import { userSchema } from './user';
export const collectionFolderSchema = new schema.Entity('collectionFolder', {
    thumb: deviationSchema,
    owner: userSchema
}, {
    idAttribute: 'folderId'
});
export const collectionListSchema = [
    collectionFolderSchema
];
collectionFolderSchema.define({
    subfolders: collectionListSchema
});
export const galleryFolderSchema = new schema.Entity('galleryFolder', {
    thumb: deviationSchema,
    owner: userSchema
}, {
    idAttribute: 'folderId'
});
export const galleryListSchema = [
    galleryFolderSchema
];
galleryFolderSchema.define({
    subfolders: galleryListSchema
});
export const stashFolderSchema = new schema.Entity('stashFolder', {
    thumb: deviationSchema,
    owner: userSchema
}, {
    idAttribute: 'folderId'
});
export const stashListSchema = [
    stashFolderSchema
];
stashFolderSchema.define({
    subfolders: stashListSchema
});

//# sourceMappingURL=folder.js.map